import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Bokeh from "@/components/Bokeh";
import Home from "@/pages/Home";
import Pricelist from "@/pages/Pricelist";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="scene-bg relative min-h-screen overflow-x-hidden" data-testid="app-shell">
          <Bokeh />
          <Navbar />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricelist" element={<Pricelist />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <footer
            data-testid="site-footer"
            className="relative z-10 border-t border-emerald-400/10 py-6 text-center text-xs tracking-[0.3em] text-emerald-200/40"
          >
            © 2026 TEAMJAV — FIRST MIXED COUNTRY GROWTOPIA TEAM
          </footer>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
